import { render } from "./professores-single.vue?vue&type=template&id=222ab54e&scoped=true"
import script from "./professores-single.vue?vue&type=script&lang=js"
export * from "./professores-single.vue?vue&type=script&lang=js"

import "./professores-single.vue?vue&type=style&index=0&id=222ab54e&lang=scss&scoped=true"
import "./professores-single.vue?vue&type=style&index=1&id=222ab54e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222ab54e"]])

export default __exports__